
<template>
  <div v-wechat-title="title">
    <!-- <TopBar :pagetitle="title" :back-url="backurl" /> -->
    <div class="topBack"><i class="iconfont iconback" @click="onBack" /></div>
    <div v-if="data && data.team" class="posterRect">
      <img :src="data.team.mainPoster">
    </div>
    <div v-if="data && data.team&&data.team.about" class="groupRectBase">
      <div class="title" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor">活动说明
        <div class="topButton"><i class="iconfont iconback" @click="onBack" /></div>
      </div>
      <div class="about" v-html="data.team.about" />
    </div>
    <div v-if="data && data.team && data.team.type==='GROUPBUY'">
      <van-button type="default" size="large" :color="data.team.baseColor" :disabled="buttonDisable" @click="onGoNextGroupBuy">参加活动</van-button>
    </div>
    <div v-if="data && data.team && (data.team.type === 'SHAREBUY' || data.team.type === 'TIMEGIFT')" class="groupDownButtonOnImg">
      <van-button type="default" size="large" :loading="buttonLoading" :disabled="buttonDisable" @click="onGoNextShareBuy" />
    </div>
    <div v-if="showMoreButton" class="readMoreButton" @click="onMoreButton"><img src="/img/readmore1.gif"></div>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <followWx v-model="showFollow" @finish="buttonDisable=false" />
    <certificateDialog v-model="showCertificate" :url="noticeUrl" @finish="onCertificateFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import { MyNotify, getUrlKey, getUserBase } from '@/utils/base'
import Cookies from 'js-cookie'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import certificateDialog from '@/components/certificateDialog'
import followWx from '@/components/followWx'
export default {
  components: {
    [Button.name]: Button,
    wxShare,
    followWx, certificateDialog
  },
  data() {
    return {
      backurl: '/store/index',
      title: '',
      key: undefined,
      data: undefined,
      id: undefined,
      showMoreButton: true,
      buttonLoading: false,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      system: undefined,
      buttonDisable: true,
      showFollow: false,
      showCertificate: false,
      noticeUrl: ''
    }
  },
  mounted: function() {
    window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮滚动事件
  },
  created() {
    this.key = this.$route.params.key
    this.system = getUrlKey('system')
    this.id = getUrlKey('id')
    if (!this.id) {
      Cookies.remove('groupKey_')
    }
    this.init()
  },
  methods: {
    onShareFinish() {
      this.shareUrl = undefined
    },
    handleScroll: function() {
      this.showMoreButton = false
    },
    onMoreButton() {
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      document.documentElement.scrollTop = clientHeight
    },
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        getUserBase(userInfo => {
          console.log('用户数据', userInfo)
          this.shareTitle = this.data.team.shareTitle.replace('[name]', userInfo ? userInfo.nickName : '')
          this.shareAbout = this.data.team.shareAbout.replace('[name]', userInfo ? userInfo.nickName : '')
          this.shareTimeline = this.data.team.shareTimeline.replace('[name]', userInfo ? userInfo.nickName : '')
          this.shareIcon = this.data.team.shareIcon
          this.shareUrl = GetSelfUrl() + 'group/group/' + this.key + '?system=' + this.system
        })
        this.title = this.data.team.shortName

        if (this.data.team.type === 'TIMEGIFT') {
          setTimeout(() => {
            this.showFollow = true
          }, 10)
        } else {
          this.buttonDisable = false
        }
      })
    },
    onBack() {
      this.$router.push('/store/index')
      // window.history.length > 1
      //   ? this.$router.go(-1)
      //   : this.$router.push('/store/index')
    },
    onGoNextGroupBuy() {
      if (this.data.commodity.length === 1 && this.data.userHaveCertificate) {
        this.$router.push('/group/groupAddress/' + this.key)
      } else {
        this.$router.push('/group/groupCommodity/' + this.key)
      }
    },
    onGoNextShareBuy() {
      if (this.data.team.type === 'SHAREBUY') {
        this.$router.push('/group/groupShareBuy/0?key=' + this.key)
      } else if (this.data.team.type === 'TIMEGIFT') {
        // this.$router.push('/group/giftBox/' + this.key)
        this.joinGroupTeam((data) => {
          console.log('joinGroupTeam data', data)
          if (data.cer.have || data.inTeam) {
            if (this.id) {
              this.$router.push('/group/giftBox/' + this.key + '?id=' + this.id)
            } else {
              this.$router.push('/group/giftBox/' + this.key)
            }
            return
          }
          // 需要提交认证材料
          this.noticeUrl = GetSelfUrl() + 'group/group/' + this.key + '?system=' + this.system
          this.showCertificate = true
        })
      }
    },
    joinGroupTeam(callback) {
      request({
        url: '/StoreHelper/joinGroupTeam',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data)
        }
      })
    },
    onCertificateFinish() {
      this.joinGroupTeam((data) => {
        console.log('onCertificateFinish joinGroupTeam data', data)
        if (data.cer.have || data.inTeam) {
          if (this.id) {
            this.$router.push('/group/giftBox/' + this.key + '?id=' + this.id)
          } else {
            this.$router.push('/group/giftBox/' + this.key)
          }
          return
        } else {
          MyNotify('error', '加入活动失败，请刷新后重试!')
        }
      })
    }
  }
}
</script>
<style scoped>
.posterRect{
    position: relative;
}
.posterRect .backIcon{
    position: absolute;
    left: 1em;
    top: 1em;
}
.posterRect img{
    width: 100%;
    display: block;
}
.about{
  font-size: 0.9em;
}
.readMoreButton{
  z-index: 100;
  position: fixed;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
}
.readMoreButton img{
  width: 10%;
}
.groupDownButtonOnImg{
  height: 6em;
  margin-top: -6em;
  filter:alpha(Opacity=0);
  -moz-opacity:0;
  opacity: 0;
}
.groupDownButtonOnImg button{
  height: 6em;
}
.topBack{
  position: absolute;
  left:0.2em;
  top: 0.5em;
  color: #fff;
  text-shadow:5px 2px 6px #000;
  z-index: 1000;
}
.topBack i{
  font-size: 1.2em;
}
</style>
